import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select from "react-select";

class GameInput extends Component {
    state = {
        games: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (!this.props.gamesArr) {
            this.fetchGames();
        }
        if (this.state.isLoading && this.props.gamesArr && this.props.gamesArr.length > 0) {
            this.setState({games: this.props.gamesArr, isLoading: false})
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.isLoading && this.props.gamesArr && this.props.gamesArr.length > 0) {
            this.setState({games: this.props.gamesArr, isLoading: false})
        }
    }

    fetchGames = () => {
        axios.get(apiUrl + 'Games/getGames')
            .then(response => {
                this.setState({ games: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching games:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { games, isLoading, isError } = this.state;
        const { games_filter, gamesUpdate, updatePage, closePatternDetails } = this.props;

        if (isError) {
            return <div>Error loading games. Please try again later.</div>;
        }

        if (isLoading) {
            return <Select isMulti isSearchable placeholder="Loading games..." />;
        }

        const options = games.map(game => ({
            value: game.game_id,
            label: game.game_name,
            color: '#9999FF'
        }));
        const animatedComponents = makeAnimated();

        const defaultOptions = games_filter.map(game_id => {
            return options.find(game_option => game_option.value === game_id) || { value: 0, label: "Invalid game id", color: '#9999FF' };
        });

        return (
            <span key={"gamesFilter"}>
                <Select
                    isMulti
                    isSearchable
                    options={options}
                    defaultValue={defaultOptions}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    placeholder={this.props.selectorText ?? "Select example games for this pattern."}
                    onChange={(val) => {
                        const retArr = val ? val.map(e => e.value) : [];
                        // console.log(retArr);
                        gamesUpdate(retArr);
                        updatePage(0);
                        closePatternDetails(null);
                    }}
                />
            </span>
        );
    }
}

export default GameInput;
